// src/components/TrialBanner.jsx
// ═══════════════════════════════════════════════════════════════════
// Banner de días restantes de trial y pantalla de bloqueo al vencer
// ═══════════════════════════════════════════════════════════════════
import React from "react";

// ── Pantalla completa cuando la empresa está inactiva ────────────
export const EmpresaInactivaScreen = ({ mensaje }) => (
  <div style={{
    minHeight: "100vh", display: "flex", alignItems: "center",
    justifyContent: "center", background: "#0f172a", padding: 24,
  }}>
    <div style={{
      maxWidth: 520, width: "100%", background: "#1e293b",
      borderRadius: 16, border: "1px solid #64748b", overflow: "hidden",
      textAlign: "center",
    }}>
      <div style={{ background: "#334155", padding: "28px 24px" }}>
        <div style={{ fontSize: 48 }}>🔒</div>
        <h1 style={{ color: "#fff", margin: "12px 0 0", fontSize: 22, fontWeight: 700 }}>
          Empresa inactiva
        </h1>
      </div>
      <div style={{ padding: "32px 28px" }}>
        <p style={{ color: "#cbd5e1", fontSize: 15, lineHeight: 1.6, margin: "0 0 24px" }}>
          {mensaje || "Esta empresa está inactiva. Contacta al administrador del sistema."}
        </p>
        <a
          href="mailto:soporte@mcteknovagroup.com"
          style={{
            display: "inline-block", background: "#6366f1", color: "#fff",
            padding: "13px 32px", borderRadius: 8, textDecoration: "none",
            fontWeight: 700, fontSize: 15, marginBottom: 16,
          }}
        >
          Contactar soporte
        </a>
        <div style={{ marginTop: 16 }}>
          <button
            onClick={() => {
              localStorage.removeItem("empresa_inactiva");
              localStorage.removeItem("token");
              localStorage.removeItem("usuario");
              window.location.href = "/";
            }}
            style={{
              background: "transparent", border: "1px solid #334155",
              color: "#64748b", padding: "8px 20px", borderRadius: 8,
              cursor: "pointer", fontSize: 13,
            }}
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  </div>
);

// ── Pantalla completa cuando el trial ha vencido ─────────────────
export const TrialVencidoScreen = ({ mensaje }) => (
  <div style={{
    minHeight: "100vh", display: "flex", alignItems: "center",
    justifyContent: "center", background: "#0f172a", padding: 24,
  }}>
    <div style={{
      maxWidth: 520, width: "100%", background: "#1e293b",
      borderRadius: 16, border: "1px solid #ef4444", overflow: "hidden",
      textAlign: "center",
    }}>
      <div style={{ background: "#ef4444", padding: "28px 24px" }}>
        <div style={{ fontSize: 48 }}>⛔</div>
        <h1 style={{ color: "#fff", margin: "12px 0 0", fontSize: 22, fontWeight: 700 }}>
          Período de prueba vencido
        </h1>
      </div>
      <div style={{ padding: "32px 28px" }}>
        <p style={{ color: "#cbd5e1", fontSize: 15, lineHeight: 1.6, margin: "0 0 24px" }}>
          {mensaje || "Tu período de prueba ha vencido. Contacta a MC Teknova Group para activar tu plan."}
        </p>
        <div style={{
          background: "#0f172a", border: "1px solid #334155", borderRadius: 10,
          padding: "16px 20px", marginBottom: 28,
        }}>
          <p style={{ color: "#94a3b8", fontSize: 13, margin: 0 }}>
            Tus datos están <strong style={{ color: "#6ee7b7" }}>seguros y disponibles</strong> al activar tu plan.
          </p>
        </div>
        <a
          href="mailto:soporte@mcteknovagroup.com"
          style={{
            display: "inline-block", background: "#6366f1", color: "#fff",
            padding: "13px 32px", borderRadius: 8, textDecoration: "none",
            fontWeight: 700, fontSize: 15, marginBottom: 16,
          }}
        >
          Contactar para activar mi plan
        </a>
        <div style={{ marginTop: 16 }}>
          <button
            onClick={() => {
              localStorage.removeItem("trial_vencido");
              localStorage.removeItem("token");
              localStorage.removeItem("usuario");
              window.location.href = "/";
            }}
            style={{
              background: "transparent", border: "1px solid #334155",
              color: "#64748b", padding: "8px 20px", borderRadius: 8,
              cursor: "pointer", fontSize: 13,
            }}
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  </div>
);

// ── Banner de aviso cuando quedan días ───────────────────────────
const TrialBanner = ({ dias }) => {
  const urgente = dias <= 3;
  const bg      = urgente ? "#7f1d1d" : "#78350f";
  const border  = urgente ? "#ef4444" : "#f59e0b";
  const color   = urgente ? "#fca5a5" : "#fcd34d";
  const icon    = urgente ? "🔴" : "⏳";

  return (
    <div style={{
      background: bg, borderBottom: `2px solid ${border}`,
      padding: "10px 24px", display: "flex", alignItems: "center",
      justifyContent: "center", gap: 12,
    }}>
      <span style={{ fontSize: 18 }}>{icon}</span>
      <p style={{ margin: 0, color, fontSize: 14, fontWeight: 600 }}>
        {urgente
          ? `⚠️ Tu período de prueba vence en ${dias} día${dias !== 1 ? "s" : ""}. ¡Activa tu plan ahora!`
          : `Tu período de prueba vence en ${dias} día${dias !== 1 ? "s" : ""}.`
        }
        {" "}
        <a
          href="mailto:soporte@mcteknovagroup.com"
          style={{ color, textDecoration: "underline", fontWeight: 700 }}
        >
          Contactar para activar
        </a>
      </p>
    </div>
  );
};

export default TrialBanner;
